module.exports = __webpack_public_path__ + "static/best-independent-bottler-9385d6e3a82690f0164689e37d3d4fb8.jpg";